module.exports = __webpack_public_path__ + "media/images/Pratish-DattaRev-e85ca6dccd80e52f926479497df0e361.jpg";